// analytics events
export type Event = "download_brochure";

export function track(event: Event, url: string, detail?: Record<string, unknown>) {
  fetch(`${process.env.API_URL}/agents/a`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      tid: document.cookie
        .split("; ")
        .find((row) => row.startsWith("tid="))
        ?.split("=")[1],
      url,
      event,
      detail,
    }),
  });
}
